import React from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'
import EmailVerificationButtonLabel from './EmailVerificationButtonLabel'
import EmailVerificationEmailRow from './EmailVerificationEmailRow'

// For the affirmPrimary prompt: a previously-verified email whose confirmation
// has gone stale. No code round trip — "Yes, it is" affirms directly.
const EmailVerificationAffirmPrimaryOffer = (props) => {
  const {
    email, onAffirm, onDifferentEmail, onRemindLater, onConfirmedAction, confirmedActionLabel,
    confirmLoading, confirmedMessage, errorMessage,
  } = props

  return (
    <div className='emailVerificationFlow-primaryOffer'>
      <EmailVerificationEnvelopeIllustration checkColor={confirmedMessage ? '#30C99C' : undefined} />
      <div className='emailVerificationFlow-title'>Is this still your email address?</div>
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Email address</div>
        <EmailVerificationEmailRow
          email={email}
          onEdit={confirmedMessage ? undefined : onDifferentEmail}
          editAriaLabel='Update email address'
        />
      </div>
      {errorMessage && (
        <div className='emailVerificationFlow-error'>{errorMessage}</div>
      )}
      {confirmedMessage && (
        <div className='emailVerificationFlow-codeEntry-verifiedMessage'>{confirmedMessage}</div>
      )}
      <button
        type='button'
        className={`btn btn--blue btn--large${confirmLoading ? ' btn--disabled' : ''}`}
        onClick={confirmedMessage ? onConfirmedAction : onAffirm}
        disabled={confirmLoading}
      >
        <EmailVerificationButtonLabel
          label={confirmedMessage ? confirmedActionLabel : 'Yes, it is'}
          loading={confirmLoading}
        />
      </button>
      {!confirmedMessage && (
        <div className='emailVerificationFlow-primaryOffer-links'>
          <button
            type='button'
            className='emailVerificationFlow-linkBtn'
            onClick={onRemindLater}
          >
            Remind me later
          </button>
        </div>
      )}
    </div>
  )
}

export default EmailVerificationAffirmPrimaryOffer
